import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

import { GridItem } from "../AddEditOtherSummary/AddEditOtherSummary.styled";

const Header = (props) => {
  const { t, title, borderRadius, align, color } = props;

  return (
    <GridItem
      fontSize="16px"
      fontWeight="700"
      borderRight="1px solid #fff"
      color="#fff"
      backgroundColor={color ?? "#0a4986"}
      padding="5px 10px"
      textAlign={align}
      gap="0rem"
      leftRadius={borderRadius === "left" ? "5px" : "0px"}
      rightRadius={borderRadius === "right" ? "5px" : "0px"}
    >
      {t(title)}
    </GridItem>
  );
};

Header.propTypes = {
  t: PropTypes.func.isRequired,
  color: PropTypes.string,
};

Header.defaultProps = {
  color: "#0a4986",
};

export default withTranslation()(Header);
